import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

const NonAuthLayout = (props) => {
  const navigate = useNavigate();

  const capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };
  const UserData = JSON.parse(localStorage.getItem("authUser"))

  useEffect(() => {
    let currentage = capitalizeFirstLetter(window.location.pathname);
    currentage = currentage.replaceAll("-", " ");
    document.title = currentage + " | Rabat ZOO";
    console.log(UserData)
  }, []);
  // if(UserData != null){
  //   return <React.Fragment>{props.children}</React.Fragment>;
  // } else{
    
  //   return <Navigate to={{ pathname: "/login", state: { from: props.location } }} />;
  // }

  if (localStorage.getItem("authUser") ) {
		return (
		  <Navigate to={{ pathname: "/dashboard", state: { from: props.location } }} />
		);
	  }

  return <React.Fragment>{props.children}</React.Fragment>;

};

export default NonAuthLayout;
